'use strict';

import Select from "../filter/Select";
import SpinWidget from "../../SpinWidget";
import Loading from "../../Loading";

export default function ItemDetail({
    item: {id, aircraft, routes, prices, tags} = {},
    imageSize = '',
    showForm = false,
    averagePrice,
    showPriceModal= false,
    formDataInit = {},
    errors = {},
    isSubmitting = false,
    onSubmit,
    onShowBarometerClick,
}) {
    const sliderRef = React.useRef()
    const sliderPaginationRef = React.useRef()
    const sliderPrevRef = React.useRef()
    const sliderNextRef = React.useRef()
    
    const [hasServerErrors, setHasServerErrors] = React.useState(false)
    
    let formData = {}

    const handleSubmit = () => {
        onSubmit && onSubmit(showForm ? formData : undefined)
    }
    
    const handleFormChange = (data) => {
        formData = data
    }

    React.useEffect(() => {
        if (sliderRef.current && sliderPaginationRef.current && sliderPrevRef.current && sliderNextRef.current) {
            new Swiper(sliderRef.current, {
                pagination: {
                    el: sliderPaginationRef.current,
                },
                navigation: {
                    nextEl: sliderNextRef.current,
                    prevEl: sliderPrevRef.current,
                }
            });
        }
    }, [id])

    React.useEffect(() => {
        const allowedKeys = ['date', 'time', 'seats'];
        if (errors && typeof errors === 'object' && Object.keys(errors).length > 0) {
            const extraKeys = Object.keys(errors).filter(key => !allowedKeys.includes(key));
            if (extraKeys.length > 0) {
                setHasServerErrors(true)
                extraKeys.map(e => console.error(errors[e]))
            }
        } else {
            setHasServerErrors(false)
        }
    }, [errors])

    const images = aircraft.images && aircraft.images[imageSize] ? aircraft.images[imageSize] : []

    let departDate, departDateFrom, departDateTo = null;
    if (showForm && routes && routes.length > 0 && routes[0]) {
        departDate = routes[0].departDate
        departDateFrom = routes[0].departDateFrom
        departDateTo = routes[0].departDateTo
    }

    const isPriceBelowAnnual = () => {
        if (!averagePrice || !prices.price || isNaN(averagePrice) || isNaN(prices.price)) return false;
        return prices.price < averagePrice
    }
    
    const showBarometerButton = () => {
        return !!showPriceModal && isPriceBelowAnnual()
    }

    const handleBarometerClick = () => {
        onShowBarometerClick && onShowBarometerClick()
    }

    return <React.Fragment>
        <div className="offer-modal__row">
            <div className="offer-modal__desc">
                <div className="offer-modal__top">
                    <div>
                        <h3 className="offer-modal__title">{aircraft.title}</h3>
                        <div className="offer-modal__info">
                            {!!aircraft.year && <span>{aircraft.year}</span>}
                            <span>{aircraft.class.title}</span>
                        </div>
                        {tags && tags.length > 0 && <div className="offer-modal__tags">
                            {tags.map((title, index) => <span key={`tags${id}${index}`} >{title}</span>)}
                        </div>}
                    </div>
                    <div className="offer-modal__sheme">
                        <img src={aircraft.class.image} alt=""/>
                    </div>
                </div>
                <div className="offer-modal__center">
                    <ul className="offer-modal__list">
                        <li>
                            <span>{tMsg('Питание')}</span>
                            <span>{aircraft.facilities.food}</span>
                        </li>
                        <li>
                            <span>{tMsg('Стюардесса')}</span>
                            <span>{aircraft.facilities.stewardess}</span>
                        </li>
                        <li>
                            <span>{tMsg('Интернет')}</span>
                            <span>{aircraft.facilities.internet}</span>
                        </li>
                        <li>
                            <span>{tMsg('WC')}</span>
                            <span>{aircraft.facilities.toilet}</span>
                        </li>
                        <li>
                            <span>{tMsg('Курение')}</span>
                            <span>{aircraft.facilities.smoke}</span>
                        </li>
                        <li>
                            <span>{tMsg('VIP-терминал')}</span>
                            <span>{aircraft.facilities.vip}</span>
                        </li>
                    </ul>
                    <ul className="offer-modal__list">
                        <li>
                            <span>{tMsg('Места')}</span>
                            <span>{aircraft.params.seats}</span>
                        </li>
                        <li>
                            <span>{tMsg('Высота салона')}</span>
                            <span>{aircraft.params.height}</span>
                        </li>
                        <li>
                            <span>{tMsg('Ширина салона')}</span>
                            <span>{aircraft.params.width}</span>
                        </li>
                        <li>
                            <span>{tMsg('Длина салона')}</span>
                            <span>{aircraft.params.length}</span>
                        </li>
                        <li>
                            <span>{tMsg('Объем багажника')}</span>
                            <span dangerouslySetInnerHTML={{__html: aircraft.params.trunk}}/>
                        </li>
                        {!!aircraft.update && <li>
                            <span>{tMsg('Обновление салона')}</span>
                            <span>{aircraft.update}</span>
                        </li>}
                    </ul>
                </div>
            </div>
            {images && images.length > 0 && <div className="offer-modal__slider">
                <div ref={sliderRef} className="swiper">
                    <div className="swiper-wrapper">
                        {images.map((image, index) => {
                            return <div key={`images${id}${index}`} className="swiper-slide">
                                <img src={image} alt=""/>
                            </div>
                        })}
                    </div>
                </div>
                <div ref={sliderNextRef} className="swiper-button-next"></div>
                <div ref={sliderPrevRef} className="swiper-button-prev"></div>
                <div ref={sliderPaginationRef} className="swiper-pagination"></div>
            </div>}
        </div>
        <div className="offer-modal__bottom">

            {(routes || []).length === 1 && (routes || []).map((route, index) => <RouteCard key={`route${index}`} route={route} index={1} />)}
            {(routes || []).length > 1 && <RouteCards routes={routes} />}

            <div className="offer-modal__control">
                <div className="offer-control__text">
                    <a href="#termsModalNoButton" data-fancybox className="offer-control__link">
                        {tMsg('Условия бронирования и отмены рейса')}
                    </a>
                </div>
                <div className="offer-control__bottom">
                    <div className="offer-control__price">

                        {showBarometerButton() && <div className="offer-control__price">
                            <a type='button' 
                               className="flight-price__graph-link offer-control__price-value el-tooltip" 
                               data-tooltip={tMsg('Цена ниже среднегодовой')} 
                               onClick={handleBarometerClick}
                            >
                                <i className="icon-down4"></i>
                                {prices.prefix}{prices.price_pretty} {prices.currency.symbol}
                            </a>
                        </div>}

                        {!showBarometerButton() && <div className="offer-control__price-value">
                            {prices.prefix}{prices.price_pretty} {prices.currency.symbol}
                        </div>}

                        {showForm && <Form
                            departDate={departDate}
                            departDateFrom={departDateFrom}
                            departDateTo={departDateTo}
                            maxSeats={aircraft.params.seats}
                            errors={errors}
                            formDataInit={formDataInit}
                            onChange={(data) => handleFormChange(data)}
                        />}

                    </div>

                    <div className="offer-control__btn mt-auto">
                        {hasServerErrors && <div className="offer_error">{tMsg('Произошла ошибка сервера')}</div>}
                        <button disabled={isSubmitting} className="button button-base" onClick={handleSubmit}>
                            {!isSubmitting && tMsg('Получить предложение')}
                            {<Loading active={isSubmitting} absolute={false} styleContainer={{padding:0,position:'absolute',justifyContent:'center',height:'100%'}} style={{height:'27px',width:'27px'}}/>}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        
    </React.Fragment>
}

const cardHeight = 140;

function RouteCard({
    route: {from, to, departDate, departDateFrom, departDateTo, departTime, departTimeFrom, departTimeTo, flightTime},
    isHovered = false,
    index = 0,
    count = 1,
}) {
    const isFirst = index === 0;

    const dateFrom = window.moment ? moment((departDate || departDateFrom), 'DD.MM.YYYY').format("D MMMM") : (departDate || departDateFrom);
    const timeFrom = departTime || departTimeFrom;
    const dateTo = departTimeTo ? (window.moment ? moment((departDateTo), 'DD.MM.YYYY').format("D MMMM") : departDateTo) : undefined;
    const timeTo = departTimeTo || undefined;

    const reverse = count - index;
    const translateY = isHovered ? reverse * -cardHeight : 0;
    
    return <div className={cn('direction-card', isFirst && 'first')} 
                style={{ 
                    transform: `translate(0, ${translateY}px)`, 
                    zIndex: count - index, 
                    top: isHovered ? 0 : index * 10 + 'px' 
                }}>
        <div className="direction-card__header">
            <div className="direction-card__date">
                {`${dateFrom} (${timeFrom}) ${!!dateTo ? '—' : ''}`}
                {!!dateTo && <br/>}
                {!!dateTo &&`${dateTo} (${timeTo})`}
            </div>
            <div className="direction-card__time">
                {flightTime}
            </div>
        </div>
        <div className="direction-card__way">
            <div className="direction-card__code">{from.icao}</div>
            <div className="direction-card__line">
                <span></span>
                <div className="solid-left"></div>
                {isFirst && <span></span>}
                {!isFirst && <i className="icon-plane2"></i>}
                <div className="solid-right"></div>
                <span></span>
            </div>
            <div className="direction-card__code">{to.icao}</div>
        </div>
        <div className="direction-card__city">

            <div className="direction-card__sub">
                {tMsg('Время в пути')}
            </div>
            <div className="direction-card__city-from">
                {from.city && <span>{from.city + (from.airport ? ', ' : '')}</span>}
                {from.airport && <span>{from.airport}</span>}
            </div>
            <div className="direction-card__city-to">
                {to.city && <span>{to.city + (to.airport ? ', ' : '')}</span>}
                {to.airport && <span>{to.airport}</span>}
            </div>
        </div>
    </div>
}

function RouteCards({routes = []}) {
    
    const cardsWrapp = React.useRef()
    const cardsContainer = React.useRef()
    const routesTransformed = [routes[0], ...routes].map((route) => ({route}))
    const [isHovered, setIsHovered] = React.useState(false);
    
    const closedHeight = cardHeight + routes.length * 10;

    React.useEffect(() => {
        const handleMouseEnter = () => setIsHovered(() => true);
        const handleMouseLeave = () => setIsHovered(() => false);
        
        if (cardsContainer.current) {
            const $cardsWrapper = $(cardsContainer.current);
            $cardsWrapper.on('mouseenter', handleMouseEnter);
            $cardsWrapper.on('mouseleave', handleMouseLeave);
        }
        
        return () => {
            if (cardsContainer.current) {
                const $cardsWrapper = $(cardsContainer.current);
                $cardsWrapper.off('mouseenter', handleMouseEnter);
                $cardsWrapper.off('mouseleave', handleMouseLeave);
            }
        }
    }, [])
    
    if (routes.length === 0) 
        return null;
    
    return <div ref={cardsWrapp} className="offer-modal__cards-wrapp" 
                style={{ height: (closedHeight - 10) + 'px' }}>
        <div ref={cardsContainer}
             className={cn("offer-modal__cards", isHovered && 'open')}
             style={{ marginTop: isHovered ? (routes.length * 10) + 'px' : 0 }}>
            {routesTransformed.map(({route}, index) => <RouteCard key={`route${index}`} route={route} index={index} count={routes.length} isHovered={isHovered} />)}
        </div>
    </div>
}

function Form({departDate = null, departDateFrom = null, departDateTo = null, maxSeats = 10, errors = {}, formDataInit = {}, onChange}) {
    
    const [dateList, setDateList] = React.useState([])
    const [timeList, setTimeList] = React.useState([])
    const [dateValue, setDateValue] = React.useState('')
    const [timeValue, setTimeValue] = React.useState('12:00')
    const [seatsValue, setSeatsValue] = React.useState(1)

    const handleDateChange = (value) => {
        setDateValue(() => value)
    }
    const handleTimeChange = (value) => {
        setTimeValue(value)
    }
    const handleSeatsChange = (value) => {
        setSeatsValue(value)
    }
    const handleChangeValue = () => {
        onChange && onChange({
            date: dateValue,
            time: timeValue,
            seats: seatsValue,
        })
    }
    
    React.useEffect(() => {
        handleChangeValue()
    }, [dateValue, timeValue, seatsValue])
    
    const getValue = (moment) => {
        return moment.format('DD.MM.YYYY')
    }
    const getTitle = (moment) => {
        return moment.format('DD.MM.YYYY')
    }
    
    React.useEffect(() => {
        
        // ДАТЫ

        const dateList = []
        
        const depart_moment = departDate ? moment(departDate, 'DD.MM.YYYY') : null;
        const depart_from_moment = departDateFrom ? moment(departDateFrom, 'DD.MM.YYYY') : null;
        let depart_to_moment = departDateTo ? moment(departDateTo, 'DD.MM.YYYY') : null;

        if (depart_from_moment && depart_from_moment.isValid() && depart_to_moment && depart_to_moment.isValid()) {
            
            const now = moment().startOf('day')
            const depart_from_moment_actual = depart_from_moment.startOf('day').isBefore(now) ? now : depart_from_moment;
            
            if (depart_to_moment.startOf('day').isBefore(depart_from_moment_actual.startOf('day'))) {
                depart_to_moment = depart_from_moment_actual;
                console.error('Неверный диапазон');
            }
            
            handleDateChange(getTitle(depart_from_moment_actual))

            while (depart_from_moment_actual.isSameOrBefore(depart_to_moment.startOf('day'))) {
                dateList.push({
                    id: getValue(depart_from_moment_actual),
                    title: getTitle(depart_from_moment_actual)
                });
                depart_from_moment_actual.add(1, 'days');
            }
            
        } else if (depart_moment && depart_moment.isValid()) {

            handleDateChange(getTitle(depart_moment))
            dateList.push({
                id: getValue(depart_moment),
                title: getTitle(depart_moment)
            });

        }
        
        setDateList(dateList)

        
        // ВРЕМЯ
        
        const timeList = Array.from({ length: 48 }, (_, i) => {
            const hh = String(Math.floor(i / 2)).padStart(2, '0');
            const mm = (i % 2 === 0) ? '00' : '30';
            const value = hh + ':' + mm;
            return {id: value, title: value};
        });
        
        setTimeList(timeList)
        
    }, [])

    React.useEffect(() => {
        if (formDataInit && typeof formDataInit === 'object') {
            if (formDataInit.date && dateList.find(e => e.id == formDataInit.date)) handleDateChange(formDataInit.date)
            if (formDataInit.time) handleTimeChange(formDataInit.time)
            if (formDataInit.seats) handleSeatsChange(parseInt(formDataInit.seats))
        }
    }, [formDataInit, dateList])
    
    return <div className="offer-control__form">
        <div className="offer-control__row">
            
            <Select
                keyPrefix={'form'}
                items={dateList}
                value={dateValue}
                parentClass={'search-date search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                disabled={dateList.length === 1}
                error={!!errors.date}
                onChange={(value) => handleDateChange(value)}
            />

            <Select
                keyPrefix={'form'}
                items={timeList}
                value={timeValue}
                parentClass={'search-time inputbox'}
                selectClass={"offer-selectbox"}
                dropdownClass={'offer-selectbox-drop'}
                useBodyAsParent={true}
                required={true}
                error={!!errors.time}
                onChange={(value) => handleTimeChange(value)}
            />
            
            <SpinWidget
                className={'search-inputbox search-count'}
                value={seatsValue}
                minValue={1}
                maxValue={maxSeats}
                error={!!errors.seats}
                errorClass={'error_border'}
                onChange={(value) => handleSeatsChange(value)}
            />
        </div>
    </div>
}